import { Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import {
  DeltaHedgeAccountsUploadFileMode,
  IAddDeltaHedgeAccount,
  IDeltaHedgeAccountAggregateReport,
  IDeltaHedgeAccountAggregateReportSearchParam,
  IDeltaHedgeAccountDetailReportSearchParam,
  IDeltaHedgeAccountFormValues,
  IDeltaHedgeAccountSearchParam,
  IDeltaHedgeAccountTableReport,
  IDeltaHedgeAccountChartsReport,
  IDeltaHedgeAccountChartsChartSearchParam,
  IPortfoPairPositionSearchParam,
  IPortfoPairPositionTableReport,
  IRolePairPositionTableReport,
  IRolePairPositionSearchParam,
  StrategyReport,
  IStrategySearchParam,
  IStrategyDto,
  IDeltaHedgeAccountDesiredBoundryChartSearchParam,
  ChartData,
  IPortfoPairPositionFilterSetting,
  IRolePairPositionFilterSetting,
} from "../Interfaces/deltaHedgeAccounts";
import { DropdownItem } from "../Interfaces/dropdownInterfaces";
import {
  deleteRequest,
  getDownloadExcel,
  getRequest,
  getTable,
  postDownloadExcel,
  postRequest,
  putRequest,
} from "./requestTemplates";
import { Graph_Dto } from "../Interfaces/orderbookGraphInterfaces";
import { AxiosRequestConfig } from "axios";

export const getHedgeAccountInstruments = (): Promise<DropdownItem[]> =>
  getRequest("/v1/deltaHedgeAccount/GetInstruments");

export const getDeltaHedgeAccountsTable = (
  searchParam: IDeltaHedgeAccountSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IDeltaHedgeAccountTableReport>> =>
  getTable<IDeltaHedgeAccountSearchParam, IDeltaHedgeAccountTableReport>(
    "/v1/DeltahedgeAccount/AccountTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const upsertDeltaHedgeAccount = (
  formValues: IDeltaHedgeAccountFormValues,
): Promise<Packet<boolean>> =>
  postRequest("/v1/deltaHedgeAccount/Upsert", formValues);

export const deleteDeltaHedgeAccount = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/deltaHedgeAccount/delete?id=${id}`);

export const uploadDeltaHedgeAccountFile = (
  file: FormData,
  mode: DeltaHedgeAccountsUploadFileMode,
): Promise<Packet<boolean>> =>
  postRequest(
    `/v1/deltaHedgeAccount/UploadExcelfile?uploadFileModel=${mode}`,
    file,
  );

export const getDeltaHedgeAccountsExcelTemplate = () => {
  const rand = Math.random();
  return getDownloadExcel(
    `/v1/DeltaHedgeAccount/DownloadExcelTemplate?${rand}`,
  );
};

export const getDeltaHedgeInstruments = (): Promise<DropdownItem[]> =>
  postRequest("/v1/deltaHedgeAccount/getInstruments", {});

export const getDetailsTable = (
  searchParam: IDeltaHedgeAccountDetailReportSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<any>> =>
  getTable<IDeltaHedgeAccountDetailReportSearchParam, any>(
    "/v1/DeltahedgeAccount/GetAccountAggeragatedByInsGroupPortfo",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getAggregateExcel = () => {
  const rand = Math.random();
  return getDownloadExcel(
    `/v1/DeltahedgeAccount/GetAccountAggeragatedByAccountPortfoExcel?${rand}`,
  );
};

export const getAggregateTable = (
  searchParam: IDeltaHedgeAccountAggregateReportSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<any>> =>
  getTable<
    IDeltaHedgeAccountAggregateReportSearchParam,
    IDeltaHedgeAccountAggregateReport
  >(
    "/v1/DeltahedgeAccount/GetAccountAggeragatedByAccountPortfo",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getVolatilityChart = (
  searchParam: IDeltaHedgeAccountChartsChartSearchParam,
): Promise<Report<IDeltaHedgeAccountChartsReport>> =>
  postRequest(
    "/v1/DeltaHedgeAccount/GetAccountAggeragatedByAccountPortfo/VolatilitySensitivityChart?Offset=0&Pagesize=10000",
    searchParam,
  );
export const getPriceChart = (
  searchParam: IDeltaHedgeAccountChartsChartSearchParam,
): Promise<Report<IDeltaHedgeAccountChartsReport>> =>
  postRequest(
    "/v1/DeltaHedgeAccount/GetAccountAggeragatedByAccountPortfo/PriceSensitivityChart?Offset=0&Pagesize=10000",
    searchParam,
  );
export const getTimeChart = (
  searchParam: IDeltaHedgeAccountChartsChartSearchParam,
): Promise<Report<IDeltaHedgeAccountChartsReport>> =>
  postRequest(
    "/v1/DeltaHedgeAccount/GetAccountAggeragatedByAccountPortfo/TimeSensitivityChart?Offset=0&Pagesize=10000",
    searchParam,
  );

export const getAccountPortfoTable = (
  searchParam: IDeltaHedgeAccountDetailReportSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<any>> =>
  getTable<IDeltaHedgeAccountDetailReportSearchParam, any>(
    "/v1/DeltahedgeAccount/GetAccountPortfo",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getAccountPortfoExcel = () => {
  const rand = Math.random();
  return getDownloadExcel(
    `/v1/DeltahedgeAccount/GetAccountPortfoExcel?${rand}`,
  );
};

export const getApplyList = (): Promise<string[]> =>
  getRequest("/v1/DeltahedgeAccount/GetApplyList");

export const setApplyList = (ids: string[]): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltahedgeAccount/SetApplyList", { ids });

export const getDeltaHedgeAccountsDropdown = (): Promise<DropdownItem[]> =>
  getRequest("/v1/DeltaHedgeAccount/AccountDropDown");

export const getPortfoPairPositionTable = (
  searchParam: IPortfoPairPositionSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IPortfoPairPositionTableReport>> =>
  getTable<IPortfoPairPositionSearchParam, IPortfoPairPositionTableReport>(
    "/v1/DeltahedgeAccount/getPortfoPairPosition",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getPortfoPairPositionExcel = () => {
  const rand = Math.random();
  return getDownloadExcel(
    `/v1/DeltahedgeAccount/getPortfoPairPositionExcel?${rand}`,
  );
};

export const getRolePairPositionTable = (
  searchParam: IRolePairPositionSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IRolePairPositionTableReport>> =>
  getTable<IRolePairPositionSearchParam, IRolePairPositionTableReport>(
    "/v1/DeltahedgeAccount/getRolePairPosition",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getRolePairPositionExcel = () => {
  const rand = Math.random();
  return getDownloadExcel(
    `/v1/DeltahedgeAccount/getRolePairPositionExcel?${rand}`,
  );
};

/**
 * Delta Hedge => Delta Hedge Accounts => Accounts
 * جدول استراتژی ها
 *
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getStrategyTable = (
  searchParam: IStrategySearchParam,
  offset: number | null,
  pageSize: number | null,
): Promise<Report<StrategyReport>> =>
  getTable<IStrategySearchParam, StrategyReport>(
    "/v1/DeltahedgeAccount/strategyTable",
    searchParam,
    offset,
    pageSize,
  );

/**
 * Delta Hedge => Delta Hedge Accounts => Accounts
 * ثبت استراتژی جدید
 *
 * @param {IStrategyDto} dto
 * @async
 * @version 1.4.0
 */
export const addStrategy = (dto: IStrategyDto): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltaHedgeAccount/AddStrategy", dto);

/**
 * Delta Hedge => Delta Hedge Accounts => Accounts
 * ویرایش استراتژی
 *
 * @param {IStrategyDto} data
 * @async
 * @version 1.4.0
 */
export const editStrategy = (dto: IStrategyDto): Promise<Packet<boolean>> =>
  putRequest("/v1/DeltaHedgeAccount/EditStrategy", dto);

/**
 * Delta Hedge => Delta Hedge Accounts => Accounts
 * حذف استراتژی
 *
 * @param {number} id
 * @async
 * @version 1.4.0
 */
export const deleteStrategy = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/DeltaHedgeAccount/deleteStrategy?strategyId=${id}`);

/**
 * Delta Hedge => Delta Hedge Accounts => Accounts
 *  لیست استراتژی‌ها
 *
 * @async
 * @version 1.4.0
 */
export const getStrategies = async (): Promise<Array<DropdownItem>> =>
  getRequest(`/v1/DeltaHedgeAccount/GetStrategyDropdown`);

/**
 * Delta Hedge => Delta Hedge Accounts => Accounts
 * ویرایش اکانت
 *
 * @param {IAddDeltaHedgeAccount} data
 * @async
 * @version 1.4.0
 */
export const editAccount = (
  dto: IAddDeltaHedgeAccount,
): Promise<Packet<boolean>> =>
  putRequest("/v1/DeltaHedgeAccount/EditAccount", dto);

/**
 * Delta Hedge => Delta Hedge Accounts => Accounts
 * افزودن اکانت
 *
 * @param {IAddDeltaHedgeAccount} data
 * @async
 * @version 1.4.0
 */
export const addDeltaHedgeAccount = (
  dto: IAddDeltaHedgeAccount,
): Promise<Packet<boolean>> =>
  postRequest("/v1/DeltahedgeAccount/AddAccount", dto);

/**
 * Delta Hedge => Delta Hedge Accounts => Accounts
 * لیست پروفایل‌ها
 *
 * @async
 * @version 1.4.0
 */
export const getProfiles = async (): Promise<Array<DropdownItem>> =>
  getRequest(`/v1/DeltaHedgeBacktest/GetProfiles`);

/**
 * Delta Hedge => Delta Hedge Accounts => Portfo Pair Position
 * لست کاربرها
 *
 * @async
 * @version 1.4.0
 */
export const getDeltaHedgeAccountsForPortfoDropdown = (): Promise<
  DropdownItem[]
> => getRequest("/v1/DeltaHedgeAccount/DeltaHedgeUserDropDown");

/**
 * Delta Hedge => Delta Hedge Accounts => Aggregate => Desired Boundry Chart
 * دریافت داده‌های چارت مرز ترجیحی
 *
 * @async
 * @version 1.4.0
 */
export const getDesiredBoundryChart = (
  searchParam: IDeltaHedgeAccountDesiredBoundryChartSearchParam,
): Promise<ChartData> =>
  postRequest("/v1/DeltaHedgeAccount/GetDesiredBoundry", searchParam);

/**
 * Delta Hedge => Delta Hedge Accounts => Portfo Pair Position
 * گرفتن تنظیمات فیلتر
 *
 * @async
 * @version 1.4.0
 */
export const getFilterSetting = (): Promise<IPortfoPairPositionFilterSetting> =>
  getRequest("/v1/OptionDomain/portfoPairPosition/getpreset");

/**
 * Delta Hedge => Delta Hedge Accounts => Portfo Pair Position
 * ثبت تنظیمات فیلتر
 *
 * @param {IPortfoPairPositionFilterSetting} config
 * @async
 * @version 1.4.0
 */
export const setFilterSetting = (
  config: IPortfoPairPositionFilterSetting,
): Promise<Packet<boolean>> =>
  putRequest("/v1/OptionDomain/portfoPairPosition/setpreset", config);

/**
 * Delta Hedge => Delta Hedge Accounts => Portfo Pair Position
 * گرفتن تنظیمات فیلتر
 *
 * @async
 * @version 1.4.0
 */
export const getRollFilterSetting =
  (): Promise<IRolePairPositionFilterSetting> =>
    getRequest("/v1/OptionDomain/rollPairPosition/getpreset");

/**
 * Delta Hedge => Delta Hedge Accounts => Portfo Pair Position
 * ثبت تنظیمات فیلتر
 *
 * @param {IPortfoPairPositionFilterSetting} config
 * @async
 * @version 1.4.0
 */
export const setRollFilterSetting = (
  config: IRolePairPositionFilterSetting,
): Promise<Packet<boolean>> =>
  putRequest("/v1/OptionDomain/rollPairPosition/setpreset", config);
